export const BetPrice = (props) => {
    const {price} = props;
    return <div style={{backgroundColor: '#22262e', paddingTop: '6px', paddingBottom: "6px", paddingLeft: "10px", paddingRight: '10px', borderRadius: '8px', border: "1px solid #363844", justifySelf: "center", width: "max-content"}}>
        {price}
    </div>
}

export const BetPriceDropdown = (props) => {
    const {price} = props;
    return <div style={{backgroundColor: price ? '#17191d' : '', paddingTop: '6px', paddingBottom: "6px", paddingLeft: "10px", paddingRight: '10px', borderRadius: '8px', border: price ? "1px solid #363844" : '', justifySelf: "center", color: '#eff1f5', height: '52px', alignContent: 'center'}}>
        {price}
    </div>
}